/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Demo_PlayInputs */

const en_why_listening_demo_play = /** @type {(inputs: Why_Listening_Demo_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play the Listening demo`)
};

const es_why_listening_demo_play = /** @type {(inputs: Why_Listening_Demo_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducir la demo de Listening`)
};

/**
* | output |
* | --- |
* | "Play the Listening demo" |
*
* @param {Why_Listening_Demo_PlayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_demo_play = /** @type {((inputs?: Why_Listening_Demo_PlayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Demo_PlayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_demo_play(inputs)
	return en_why_listening_demo_play(inputs)
});